module.exports = __webpack_public_path__ + "img/error.b2a5484c.png";